<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="lg"
      title="Export"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <div class="modal-body">
        <form class="">
          <div class="form-row">
            <div class="form-group col">
              <label class="form-label">Language</label>
              <b-form-select v-model="code" :options="codeOptions"></b-form-select>
            </div>
            <div class="form-group col"><label class="form-label">Format</label>
              <div class="pt-1">
                <div class="form-check form-check-inline">
                  <b-form-radio v-model="format" name="format" value="json">json</b-form-radio>
                </div>
                <div class="form-check form-check-inline">
                  <b-form-radio v-model="format" name="format" value="csv">csv</b-form-radio>
                </div>
              </div>
            </div>
            <div class="form-group col"></div>
            <div class="d-flex align-items-end justify-content-end form-group col-sm-2">
              <button type="button" @click="exportTranslation" class="btn btn-success btn-sm">Export</button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalShow: false,
      format: 'json',
      code: 'en'
    }
  },
  props: [
    'languages'
  ],
  methods: {
    exportTranslation() {
      this
        .$http({
          url: '/api/v1/localization/export/' + this.code + '.' + this.format,
          method: 'GET',
          responseType: 'blob',
        })
        .then((response) => {
          console.log(response);
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', this.code + '.' + this.format);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.modalShow = false;
        })
        .catch((err) => {
          console.log(err);
        })
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
  },
  computed: {
    codeOptions() {
      return this.languages
        .map((item) => {
          return {value: item.code, text: item.name + ' (' + item.code + ')'}
        })
        .sort((a,b) => a.text > b.text ? 1 : -1);
    }
  },
}
</script>
